import { useEffect } from "react";
import { Routes, Route} from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import theme from "assets/theme";
import { useSoftUIController } from "context";
import Home from "../Home";
import { RefreshProvider } from 'helpers/RefreshContext';

export default function App() {
  const [controller] = useSoftUIController();
  const { direction } = controller;

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RefreshProvider>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </RefreshProvider>

        <ToastContainer />
      </ThemeProvider>
    </>
  );
}
